import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Header, Footer } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Portfolio from "@/pages/Portfolio";
import WeddingFilms from "@/pages/WeddingFilms";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import TestimonialsPage from "@/pages/Testimonials";
import Reviews from "@/pages/Reviews";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import PublicContractSign from "@/pages/PublicContractSign";
import CityPage from "@/pages/CityPage";
import BookConsultation from "@/pages/BookConsultation";
import GalleryDetail from "@/pages/GalleryDetail";
import { SnapPicServicePage, StorySongServicePage } from "@/pages/ExperienceServicePages";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import GalleryEditor from "@/pages/admin/GalleryEditor";
import BlogEditorPage from "@/pages/admin/BlogEditorPage";
import SocialPopup from "@/components/SocialPopup";
import LogoIntro from "@/components/LogoIntro";
import api from "@/lib/api";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AdminNoIndex() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isAdmin = pathname.startsWith("/admin");
    let meta = document.querySelector('meta[name="robots"][data-admin="1"]');
    if (isAdmin) {
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "robots");
        meta.setAttribute("data-admin", "1");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", "noindex, nofollow, noarchive, nosnippet");
    } else if (meta) {
      meta.remove();
    }
  }, [pathname]);
  return null;
}

function PublicLayout({ children, settings }) {
  return (
    <>
      <LogoIntro settings={settings} />
      <Header />
      <main className="pt-0">{children}</main>
      <Footer settings={settings} />
      <SocialPopup settings={settings} />
    </>
  );
}

function App() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  return (
    <BrowserRouter>
      <ScrollTop />
      <AdminNoIndex />
      <Toaster theme="dark" position="top-right" />
      <Routes>
        <Route path="/" element={<PublicLayout settings={settings}><Home settings={settings} /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout settings={settings}><About /></PublicLayout>} />
        <Route path="/portfolio" element={<PublicLayout settings={settings}><Portfolio /></PublicLayout>} />
        <Route path="/portfolio/:slug" element={<PublicLayout settings={settings}><GalleryDetail /></PublicLayout>} />
        <Route path="/films" element={<PublicLayout settings={settings}><WeddingFilms /></PublicLayout>} />
        <Route path="/services" element={<PublicLayout settings={settings}><Services /></PublicLayout>} />
        <Route path="/services/snappic" element={<PublicLayout settings={settings}><SnapPicServicePage /></PublicLayout>} />
        <Route path="/services/story-song" element={<PublicLayout settings={settings}><StorySongServicePage /></PublicLayout>} />
        <Route path="/services/:slug" element={<PublicLayout settings={settings}><ServiceDetail /></PublicLayout>} />
        <Route path="/testimonials" element={<PublicLayout settings={settings}><TestimonialsPage /></PublicLayout>} />
        <Route path="/reviews" element={<PublicLayout settings={settings}><Reviews settings={settings} /></PublicLayout>} />
        <Route path="/faq" element={<PublicLayout settings={settings}><FAQ /></PublicLayout>} />
        <Route path="/blog" element={<PublicLayout settings={settings}><Blog /></PublicLayout>} />
        <Route path="/blog/:slug" element={<PublicLayout settings={settings}><BlogDetail /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout settings={settings}><Contact settings={settings} /></PublicLayout>} />
        <Route path="/contracts/:token" element={<PublicContractSign />} />
        <Route path="/book" element={<PublicLayout settings={settings}><BookConsultation /></PublicLayout>} />
        <Route path="/wedding-photographer/:slug" element={<PublicLayout settings={settings}><CityPage /></PublicLayout>} />

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/forgot-password" element={<AdminForgotPassword />} />
        <Route path="/admin/reset-password" element={<AdminResetPassword />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/galleries/:gid" element={<GalleryEditor />} />
        <Route path="/admin/blog/:id" element={<BlogEditorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
